'use strict';

/**
 * inviewイベントをディスパッチ
 */
var initInviewEvent = function initInviewEvent() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

  var DELAY = 0.1;
  var elements = document.querySelectorAll('.js-inview');

  // 連続した要素はDelayを計算してdatasetに設定
  var currentIndex = void 0;
  elements.forEach(function (element, index) {
    var previousElement = element.previousElementSibling;

    // Check if the previous element is not a .js-fadeIn or if it's the first element
    if (!previousElement || !previousElement.classList.contains('js-inview')) {
      currentIndex = 0; // Reset index for a new group
    }

    element.dataset.delay = currentIndex * DELAY + 's';
    currentIndex++;
  });

  // スクロール値を判別してイベントを発火
  window.addEventListener('scroll', function () {
    elements.forEach(function (element) {
      var rect = element.getBoundingClientRect();
      var viewHeight = window.innerHeight || document.documentElement.clientHeight;

      var thisOffset = element.dataset.offset || offset;

      if (rect.top <= viewHeight - thisOffset) {
        if (!element.classList.contains('is-active')) {
          // is-activeの時にはdelayを設定
          var delay = element.dataset.delay;
          element.style.transitionDelay = delay;

          element.classList.add('is-active');
          var event = new CustomEvent('inview');
          element.dispatchEvent(event);
        }
      } else {
        if (element.classList.contains('is-active')) {
          // 要素を消すのにはdelayしない
          element.style.transitionDelay = null;

          element.classList.remove('is-active');
          var _event = new CustomEvent('resetInview');
          element.dispatchEvent(_event);
        }
      }
    });
  });
};

/**
* グラフ設定
*/

/**
* videoのinview再生
*/
var initViedo = function initViedo() {
  var video = document.querySelector('.js-video');
  var videoElement = video.querySelector('video');

  video.addEventListener('inview', function () {
    setTimeout(function () {
      videoElement.play();
    }, 100);
  });

  video.addEventListener('resetInview', function () {
    videoElement.pause();
    videoElement.currentTime = 0;
  });
};

/**
* モーダル設定
*/
var initModal = function initModal() {
  var modal = document.querySelector('.js-modal');
  var closeTriggers = document.querySelectorAll('.js-modalClose');
  var openTriggers = document.querySelectorAll('.js-modalOpen');

  closeTriggers.forEach(function (closeTrigger) {
    closeTrigger.addEventListener('click', function () {
      var activeContent = document.querySelector('.js-modalContent.is-active');
      activeContent.classList.remove('is-active');

      modal.classList.remove('is-active');
    });
  });

  openTriggers.forEach(function (openTrigger) {
    openTrigger.addEventListener('click', function (e) {
      var target = e.target;


      var modalKey = target.closest('[data-modal-key]').dataset.modalKey;

      // カートモーダルはLaLaモードとBeginモードで呼び出しを変える
      if (modalKey == 'addcart' && htmlMode == 'lala') {
        modalKey = 'addcart_lala';
      } else if (modalKey == 'addcart' && htmlMode == 'begin') {
        modalKey = 'addcart_begin';
      }

      var activateContent = document.querySelector('.js-modalContent[data-modal-key="' + modalKey + '"]');

      activateContent.classList.add('is-active');
      modal.classList.add('is-active');
    });
  });
};

/**
* スタイルスライダー設定
*/
console.log('hi!');

var initStyleSlider = function initStyleSlider() {
  var styleSwiper = new Swiper('.js-styleSlider', {});
};

function activateSlideItems(activateIndex) {
  var sliderItems = document.querySelectorAll('[data-slider-index]');
  sliderItems.forEach(function (el) {
    var index = el.dataset.sliderIndex;

    if (index == activateIndex) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  });
}

/**
* スライダー設定
*/
var initSlider = function initSlider() {
  var productImageSwiper = new Swiper('.js-productImageSlider', {
    loop: true,
    navigation: {
      nextEl: '.js-slide_nav_next',
      prevEl: '.js-slide_nav_prev'
    }
  });

  var num = document.querySelector('.js-current');
  productImageSwiper.on('slideChange', function (mainSwiper) {
    num.innerHTML = ('00' + (mainSwiper.realIndex + 1)).slice(-2);
  });

  var sliderItems = document.querySelectorAll('.js-detailThumb');
  sliderItems.forEach(function (sliderItem) {
    sliderItem.addEventListener('click', function (e) {
      var target = e.target;

      var clickedIndex = target.closest('.js-detailThumb').dataset.slideIndex;

      productImageSwiper.slideToLoop(clickedIndex);
    });
  });
};

/**
* コンバージョンボタン設定
*/
var initCVButton = function initCVButton() {
  var container = document.querySelector('.js-cvContainer');
  var button = document.querySelector('.js-cvButton');
  var video = document.querySelector('.js-video');

  window.addEventListener('scroll', function () {
    var containerRect = container.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var videoRect = video.getBoundingClientRect();
    var videoHeight = video.clientHeight;
    var viewHeight = window.innerHeight || document.documentElement.clientHeight;

    if (containerRect.top <= viewHeight - 70) {
      button.classList.remove('is-fixed');
    } else {
      button.classList.add('is-fixed');
    }

    if (videoRect.top + videoHeight <= viewHeight) {
      button.classList.add('is-animated');
    } else {
      button.classList.remove('is-animated');
    }
  });
};

/**
* 初期化
*/
document.addEventListener('DOMContentLoaded', function () {
  requestAnimationFrame(function () {
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    initInviewEvent(windowHeight / 3 * 2);
  });

  initViedo();
  initStyleSlider();
  initSlider();
  initModal();
  initCVButton();
});